module.exports = __webpack_public_path__ + "static/media/resize-small.89bc41b0.png";